import { flow, toString } from 'lodash/fp'
import { createSelector } from 'reselect'

import { getServiceWrapper } from 'core/service-wrapper'

import { currentQQ } from './primitive-selector'

const productCode = currentQQ('selectedDisplayProduct.code')
const basicPlanCode = currentQQ('selectedDisplayProduct.basicPlanCode')
const basicPlanName = currentQQ('selectedDisplayProduct.name')
const productRefName = currentQQ('selectedDisplayProduct.productRefName')
const productCategory = currentQQ('selectedDisplayProduct.category')

const paymentPeriod = createSelector(
  [
    currentQQ('selectedDisplayProduct.paymentPeriod.type'),
    flow(currentQQ('selectedDisplayProduct.paymentPeriod.value'), toString),
  ],
  (type, value) => ({
    type,
    value,
  })
)

const coveragePeriod = createSelector(
  [
    currentQQ('selectedDisplayProduct.coveragePeriod.type'),
    flow(currentQQ('selectedDisplayProduct.coveragePeriod.value'), toString),
  ],
  (type, value) => ({
    type,
    value,
  })
)

export const product = createSelector(
  [productCode, basicPlanCode, paymentPeriod, coveragePeriod, basicPlanName, productRefName, productCategory],
  (code, basicPlanCode, paymentPeriod, coveragePeriod, basicPlanName, productRefName, category) => ({
    code,
    basicPlanCode,
    paymentPeriod,
    coveragePeriod,
    basicPlanName,
    productRefName,
    category,
  })
)

export const productMRTA = (state) => {
  const serviceWrapper = getServiceWrapper()
  if (serviceWrapper.isCurrentProductUsePartnerApi()) {
    const p = product(state)
    return {
      code: p.basicPlanCode,
      basicPlanCode: p.code,
      paymentPeriod: p.paymentPeriod,
      coveragePeriod: p.coveragePeriod,
      basicPlanName: p.basicPlanName,
      productRefName: p.productRefName,
      category: p.category,
    }
  } else {
    return product(state)
  }
}
